import { useQuery } from 'react-query';
import ZentuvoInvoicingApi from '../ZentuvoInvoicingApi';

export const invoiceDatesQueryKey = 'zentuvo-invoicing-invoice-dates';

export function useInvoiceDatesQuery() {
    return useQuery<string[]>(invoiceDatesQueryKey, () => ZentuvoInvoicingApi.getInvoiceDates(), {
        staleTime: 5 * 60 * 1000
    });
}
